<template>
	<SectionCard :title="title" :icon="icon" class="oc-card">
		<div v-if="descrizione" class="oc-hint mb-2">{{ descrizione }}</div>
		<!-- :value e non :list: lo spostamento lo applica la pagina sull'evento drop (e salva subito) -->
		<draggable :value="items" tag="div" class="oc-lines" handle=".oc-grab" :sort="true" @change="$emit('drop', $event)">
			<div v-for="(item, index) of items" :key="item.key" class="oc-line" :class="{ 'oc-line--off': !item.active }">
				<v-icon small class="oc-grab mr-2" title="Trascina per cambiare l'ordine">mdi-drag-vertical</v-icon>
				<span class="oc-num">{{ index + 1 }}</span>
				<span class="oc-key">{{ item.key }}</span>
				<v-switch
					v-model="item.active"
					:disabled="item.key === fisso"
					:title="item.key === fisso ? 'Sempre presente' : ''"
					color="primary"
					class="mt-0 pt-0"
					hide-details
					@change="$emit('change-status')"
				></v-switch>
			</div>
			<div v-if="!items.length" class="oc-hint pa-3">Nessuna voce</div>
		</draggable>

		<!-- campi extra (es. lettere e separatore dello SKU) -->
		<slot></slot>

		<div class="oc-preview mt-3">
			<div class="oc-preview-label">Anteprima</div>
			<div class="oc-preview-text">{{ anteprima || '—' }}</div>
		</div>

		<div v-if="$slots.azioni" class="oc-actions mt-3">
			<slot name="azioni"></slot>
		</div>
	</SectionCard>
</template>

<script>
import Draggable from 'vuedraggable';
import SectionCard from '@/components/core/SectionCard.vue';

// card delle impostazioni prodotto che compongono un testo da voci ordinate (slug, SKU, etichetta):
// riordino e interruttori li salva la pagina, qui solo la vista
export default {
	name: 'OrdineCampiCard',
	components: { Draggable, SectionCard },
	props: {
		title: { type: String, required: true },
		icon: { type: String, default: '' },
		descrizione: { type: String, default: '' },
		// [{ key, active }]
		items: { type: Array, default: () => [] },
		// voce che non si puo' spegnere
		fisso: { type: String, default: '' },
		anteprima: { type: String, default: '' },
	},
};
</script>

<style scoped>
.oc-card {
	height: 100%;
}
.oc-hint {
	font-size: 12px;
	color: #5f6b7a;
}
.oc-lines {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.oc-line {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 4px 10px;
	min-height: 40px;
	font-size: 14px;
}
.oc-line + .oc-line {
	border-top: 1px solid #eef2f7;
}
.oc-line--off .oc-key {
	color: #9aa5b1;
}
.oc-grab {
	cursor: grab;
}
.oc-num {
	flex: 0 0 22px;
	font-size: 12px;
	color: #5f6b7a;
	font-variant-numeric: tabular-nums;
}
.oc-key {
	flex: 1 1 auto;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-family: 'Roboto Mono', ui-monospace, monospace;
	font-size: 13px;
}
.oc-preview {
	background: #f3f6fa;
	border: 1px dashed #c9d4e2;
	border-radius: 8px;
	padding: 8px 12px;
}
.oc-preview-label {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
}
.oc-preview-text {
	font-family: 'Roboto Mono', ui-monospace, monospace;
	font-size: 15px;
	color: #1f2d3d;
	word-break: break-all;
}
.oc-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}
</style>
